













import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

import {
    TransportLoad,
    TransportLoadTask,
} from "@/models";

import AddressCard from "./AddressCard.vue";

@Component({
    components: {
        AddressCard,
    }
})
export default class TransitionView extends Vue {
    @Prop() item!: { load: TransportLoad; loadTask: TransportLoadTask };
}
